import './OrganizationTreeSelect.css'

import { Box, Checkbox, Flex } from '@chakra-ui/react'
import { useRef } from 'react'
import TreeView, { flattenTree } from 'react-accessible-treeview'

import { OrganizationUnitTree } from '../../hooks/useRtpc'
import { ChevronRight } from '../../icons'

export const OrganizationTreeSelect = ({
  data,
  onSelectedIdsChanged,
  defaultSelectedIds,
}: {
  data: OrganizationUnitTree[]
  onSelectedIdsChanged?: (selectedIds: number[]) => void
  defaultSelectedIds: number[]
}) => {
  const treeViewRef = useRef(null)

  const treeData = data
    ? flattenTree({
        name: '',
        children: [
          {
            name: 'Všechny organizace',
            id: -1,
            children: data,
          },
        ],
      })
    : undefined

  return (
    treeData && (
      <Box pl={4}>
        <TreeView
          ref={treeViewRef}
          className="tree-select"
          data={treeData}
          aria-label="Checkbox tree"
          multiSelect
          propagateSelect
          propagateSelectUpwards
          togglableSelect
          defaultExpandedIds={[-1]}
          defaultSelectedIds={defaultSelectedIds}
          onSelect={(props) =>
            onSelectedIdsChanged &&
            onSelectedIdsChanged(
              Array.from(props.treeState.selectedIds as Set<number>),
            )
          }
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isSelected,
            isHalfSelected,
            getNodeProps,
            level,
            handleSelect,
            handleExpand,
          }) => {
            return (
              <Flex
                {...getNodeProps({ onClick: handleExpand })}
                style={{ marginLeft: 24 * (level - 1) }}
              >
                {isBranch && <ArrowIcon isOpen={isExpanded} />}
                <Checkbox
                  pl={1}
                  my={1}
                  isChecked={isSelected}
                  isIndeterminate={isHalfSelected}
                  onChange={(e) => {
                    handleSelect(
                      e as unknown as React.MouseEvent<unknown, unknown>,
                    )
                    e.stopPropagation()
                  }}
                >
                  {element.name}
                </Checkbox>
              </Flex>
            )
          }}
        />
      </Box>
    )
  )
}

const ArrowIcon = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <ChevronRight
      boxSize={4}
      className={'arrow'}
      style={{ rotate: isOpen ? '90deg' : 'none' }}
    />
  )
}
